import {Component, input} from '@angular/core';

@Component({
	selector: 'app-informations-utiles',
	templateUrl: './informations-utiles.component.html',
	styleUrl: './informations-utiles.component.scss'
})
export class InformationsUtilesComponent {
	// Inputs
	afficherTitre = input<boolean>(true);
	informations = input<string | null>(null);

	constructor() {
	}

	/**
	 * Vérifie si aucune informations utiles n'est disponibles.
	 *
	 * @return {boolean} true si les informations sont nulles ou vides, false sinon.
	 */
	aucuneInformationsUtiles(): boolean {
		return !this.informations()?.length;
	}
}
